import { useQuery } from "@tanstack/react-query";
import { getTrackByUId } from "../api";

export const useTrackQuery = ({ uid }: { uid?: string }) => {
  const query = useQuery({
    queryKey: ["track", uid],
    queryFn: () => getTrackByUId({ uid }),
    enabled: !!uid,
    select: (data) => {
      if (!data) return undefined;
      const track = data.data;
      return {
        ...track,
        owner:
          track.property.customerProperty.find((cp) => cp.currentOwner)
            ?.customer ?? track.property.customerProperty[0]?.customer,
      };
    },
  });

  

  return query;
};
